import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { ResourceProvider } from "@/Common/Resources/StaticResources";
import { Button } from "@/DesignSystem";

import styles from "./AcceptAgreementPopup.module.scss";

interface IAcceptAgreementPopupProps {
    onContinue: () => void;
    stringProvider: ResourceProvider;
    checked: boolean;
    inProgress: boolean;
}

function AcceptAgreementPopup(props: IAcceptAgreementPopupProps): JSX.Element {
    const { getText } = useTranslation(props.stringProvider);

    function onCheck(e: React.ChangeEvent): void {
        const checked = e.target.checked;
        sessionStore.dispatch(LocalOperations.Login.CheckAgreementAccept, { checked });
    }

    const footer: JSX.Element = (
        <div className={styles.footerContainer}>
            <Button
                variant="brand"
                category="primary"
                label={getText("OKLabel")}
                disabled={props.checked === false || props.inProgress}
                onClick={() => props.onContinue()}
                dataCy="login-continueButton"
            />
        </div>
    );

    return (
        <Modal
            title={getText("DisclaimerHeaderLabel").toUpperCase()}
            showOverlay
            footer={footer}
            dataCy="login-acceptAgreementPopup"
        >
            <div className="p-body">{getText("DisclaimerContent")}</div>
            <div className="p-footer flex-container flex-end">
                <div className="checkbox">
                    <label>
                        <input
                            type="checkbox"
                            value={props.checked.toString()}
                            onChange={e => onCheck(e)}
                            data-cy="login-agreementInput"
                        />
                        {getText("DisclaimerAcceptanceLabel")}
                    </label>
                </div>
            </div>
        </Modal>
    );
}

export { AcceptAgreementPopup };
